import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { smsTemplatesUrl } from "src/react-query/endPoints";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useCallback, useMemo } from "react";
export const SmsTemplateActionMenu = ({ id, onEdit }) => {
  const { teamId: parentCompanyId } = useSelectedTeam();
  const { mutate } = useMutate("smsTemplates");

  const onDelete = useCallback(() => {
    mutate({ 
      url: smsTemplatesUrl(parentCompanyId, id), 
      method: "DELETE" 
    });
  }, [parentCompanyId, id, mutate]);

  const actionList = useMemo(
    () => [
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        action: onEdit,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
      },
    ],
    [id, onDelete, onEdit]
  );

  return <ActionsMenu menuList={actionList} />;
};
